<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="商家账号：" prop="pOperNo">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.pOperNo"
                  filterable
                >
                  <template v-for="(value, key) in userList">
                    <el-option
                      :key="value.userName"
                      :label="`${value.userName}${
                            value.nickName ? '(' + value.nickName + ')  ' : ''
                          }`"
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="店铺名称：" prop="shopName">
                <el-input
                  size="small"
                  v-model="queryParams.shopName"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="启用状态：" prop="shopStatus">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.shopStatus"
                >
                  <template v-for="(value, key) in dictData['shop_status']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="是否授权：" prop="authStatus">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.authStatus"
                >
                  <template
                    lable="99"
                    v-for="(value, key) in dictData['auth_status']"
                    :value="key"
                  >
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="平台渠道：" prop="platNo">
                <el-select clearable size="small" v-model="queryParams.platNo">
                  <template v-for="(value, key) in dictData['plat_no']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="添加时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
        :layout="'slot, total, sizes, prev, pager, next, jumper'"
      >
        <span style="float: left">
          <!-- <el-button type="success" size="small" @click="handleShowEditShop({})"
            >修改</el-button
          > -->
        </span>
      </pagination>
      <el-table :data="tableData">
        <el-table-column label="添加时间" prop="createTime"></el-table-column>
        <el-table-column label="商家账号" prop="pOperNo"></el-table-column>
        <el-table-column label="平台渠道" prop="shopName">
          <template slot-scope="scope">
            <span> {{ dictMap["plat_no"][scope.row.platNo] }} </span>
          </template>
        </el-table-column>
        <el-table-column label="店铺名称" prop="shopName">
          <template slot-scope="scope">
            <el-button type="text" @click="handleShowDetail(scope.row)">{{
              scope.row.shopName
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="开户站" prop="amazonSite">
          <template slot-scope="scope">
            <span> {{ dictMap["amazon_site"][scope.row.amazonSite] }} </span>
          </template>
        </el-table-column>
        <el-table-column label="关联账号" prop="operNos"></el-table-column>
        <el-table-column label="自动同步订单" prop="isSync">
          <template slot-scope="scope">
            <span>{{ dictMap["yes_or_no"][scope.row.isSync] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="授权状态" prop="authStatus">
          <template slot-scope="scope">
            <span>{{ dictMap["auth_status"][scope.row.authStatus] }}</span>
            <br />
            <span>{{ scope.row.authTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" prop="shopStatus">
          <template slot-scope="scope">
            <span>{{ dictMap["shop_status"][scope.row.shopStatus] }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" prop="oper" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleShowAuthShop(scope.row)"
              v-if="scope.row.authStatus == '01'"
              >授权</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="handleShowRelaSubAccount(scope.row.shopId)"
              >关联账号</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="handleShowEditShop(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="giveShopAuth(scope.row.shopId, '01')"
              v-if="scope.row.shopStatus != '01'"
              >启用</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="giveShopAuth(scope.row.shopId, '02')"
              v-else
              >禁用</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="查看"
      :visible.sync="dialogVisible"
    >
      <div>
        <el-form ref="form" :model="detailForm" label-width="140px">
          <el-form-item label="店铺名称：">
            {{ detailForm.shopName }}
          </el-form-item>
          <el-form-item label="开户站：">
            {{ dictMap["amazon_site"][detailForm.amazonSite] }}
          </el-form-item>
          <el-form-item label="Amazon账号：">
            {{ detailForm.amazonAccount }}
          </el-form-item>
          <el-form-item label="卖家编号：">
            {{ detailForm.merchantId }}
          </el-form-item>
          <el-form-item label="MWS授权令牌：">
            {{ detailForm.MWS }}
          </el-form-item>
          <el-form-item label="自动同步订单："
            >{{ detailForm.isSync }}
          </el-form-item>
          <el-form-item label="授权时间：">
            {{ detailForm.authTime }}</el-form-item
          >
          <el-form-item label="店铺状态：">
            {{ dictMap["shop_status"][detailForm.shopStatus] }}
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" size="small" @click="dialogVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="关联账号"
      :visible.sync="relaSubAccount.dialogVisible"
      width="40%"
    >
      <el-table
        v-loading="relaSubAccount.loading"
        :data="relaSubAccount.tableData"
        border
        @selection-change="handleSubAccountSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column label="子账号" prop="userName"></el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="relaSubAccount.total > 0"
        :total="relaSubAccount.total"
        :page.sync="relaSubAccount.queryParams.pageNum"
        :limit.sync="relaSubAccount.queryParams.pageSize"
        @pagination="loadAccountData"
      />
      <div slot="footer">
        <el-button size="small" @click="relaSubAccount.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="addSubAccount"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
      width="30%"
    >
      <el-form
        :model="editDialog.shopForm"
        :rules="editDialog.rules"
        ref="ruleForm"
        label-width="140px"
      >
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="editDialog.shopForm.shopName"></el-input>
        </el-form-item>
        <el-form-item label="开户站" prop="amazonSite">
          <el-select
            clearable
            v-model="editDialog.shopForm.amazonSite"
            placeholder="请选择开户站"
          >
            <template v-for="(value, key) in dictData['amazon_site']">
              <el-option
                :key="key"
                :label="value.label"
                :value="value.value"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="saveShop"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="授权店铺"
      :visible.sync="authDialog.dialogVisible"
      width="30%"
    >
      <el-form
        :model="authDialog.shopForm"
        :rules="authDialog.rules"
        ref="ruleAuthForm"
        label-width="140px"
      >
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="authDialog.shopForm.shopName"></el-input>
        </el-form-item>
        <el-form-item label="开户站" prop="amazonSite">
          <el-select
            clearable
            v-model="authDialog.shopForm.amazonSite"
            placeholder="请选择开户站"
          >
            <template v-for="(value, key) in dictData['amazon_site']">
              <el-option
                :key="key"
                :label="value.label"
                :value="value.value"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="Amazon账号" prop="amazonAccount">
          <el-input v-model="authDialog.shopForm.amazonAccount"></el-input>
        </el-form-item>
        <el-form-item label="卖家编号" prop="merchantId">
          <el-input v-model="authDialog.shopForm.merchantId"></el-input>
        </el-form-item>
        <el-form-item label="MWS授权令牌" prop="token">
          <el-input v-model="authDialog.shopForm.token"></el-input>
        </el-form-item>
        <el-form-item label="自动同步订单" prop="isSync">
          <el-radio-group v-model="authDialog.shopForm.isSync">
            <template v-for="(value, key) in dictData['yes_or_no']">
              <el-radio :label="key" :key="key"> {{ value }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="authDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="saveAuthShop"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  getShopList,
  addSubAccount,
  addShop,
  updateShop,
  giveShopAuth,
  getShopData,
} from "@/api/system/shopManage"
import { listSubAccount } from "@/api/system/user"
import { listUser } from "@/api/business/merchantManage"

export default {
  components: { Breadcrumb },
  data() {
    return {
      allCountries: {},
      countries: [],
      queryParams: {
        shopStatus: "",
        platNo: "",
        authStatus: "",
        shopName: "",
        beginTime: "",
        endTime: "",
        time: "",
        pageSize: 30,
        pageNum: 1,
        pOperNo: "",
      },
      detailForm: {},
      dialogVisible: false,
      total: 0,
      loading: false,
      tableData: [],
      relaSubAccount: {
        dialogVisible: false,
        shopId: "",
        total: 0,
        loading: false,
        tableData: [],
        queryParams: {
          pageSize: 30,
          pageNum: 1,
        },
        multipleSelection: [],
      },
      editDialog: {
        title: "",
        dialogVisible: false,
        shopForm: {},
        rules: {
          shopName: [
            { required: true, message: "请输入店铺名称", trigger: "blur" },
          ],
          amazonSite: [
            { required: true, message: "请选择开户站", trigger: "blur" },
          ],
        },
      },
      authDialog: {
        dialogVisible: false,
        shopForm: {},
        rules: {
          shopName: [
            { required: true, message: "请输入店铺名称", trigger: "blur" },
          ],
          amazonSite: [
            { required: true, message: "请选择开户站", trigger: "blur" },
          ],
          amazonAccount: [
            { required: true, message: "请输入Amazon账号", trigger: "blur" },
          ],
          merchantId: [
            { required: true, message: "请输入卖家编号", trigger: "blur" },
          ],
          token: [
            { required: true, message: "请输入MWS授权令牌", trigger: "blur" },
          ],
          isSync: [
            {
              required: true,
              message: "请选择是否自动同步订单",
              trigger: "change",
            },
          ],
        },
      },
      userList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  mounted() {
    this.loadData()
    this.loadAllCountry()
    this.getUserList()
  },
  methods: {
    async getUserList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.userList = result.rows
    },
    loadAllCountry() {
      let that = this
      $.ajax({
        url: process.env.BASE_URL + "country.json",
        method: "get",
        success: function (res) {
          let all = []
          // res.map.forEach((value,key) =>{
          //     all.concat(value);
          // });
          for (let key in res.map) {
            all = all.concat(res.map[key])
          }
          res.map["0"] = all
          that.allCountries = JSON.parse(JSON.stringify(res))
          that.countries = that.allCountries.map["0"]
        },
      })
    },

    /* 获取列表数据 */
    loadData() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      getShopData(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    resetForm() {
      this.$refs["form"].resetFields()
    },
    handleShowDetail(row) {
      this.dialogVisible = true
      this.detailForm = row
    },
    handleShowRelaSubAccount(shopId) {
      this.relaSubAccount.dialogVisible = true
      this.relaSubAccount.shopId = shopId
      this.loadAccountData()
    },
    /* 获取子账号列表数据 */
    loadAccountData() {
      this.relaSubAccount.loading = true
      let params = {}
      delete params["time"]
      listSubAccount(params).then((response) => {
        this.relaSubAccount.tableData = response.rows
        this.relaSubAccount.total = response.total
        this.relaSubAccount.loading = false
      })
    },
    /*表选中事件 */
    handleSubAccountSelectionChange(val) {
      this.relaSubAccount.multipleSelection = val
    },
    /* 获取子账号列表数据 */
    addSubAccount() {
      let operNo = []
      if (this.relaSubAccount.multipleSelection.length == 0) {
        this.$message.warning("请选择子账户！")
        return
      } else {
        this.relaSubAccount.multipleSelection.forEach((row) => {
          operNo.push(row.userId)
        })
      }
      let params = {
        shopId: this.relaSubAccount.shopId,
        operNo: operNo.join(","),
      }
      addSubAccount(params).then((response) => {
        if (response.code == "200") {
          this.$message.success("关联成功！")
          this.relaSubAccount.dialogVisible = false
          this.loadData()
        } else {
          this.$message.error("关联失败")
        }
      })
    },
    /**显示编辑页面 */
    handleShowEditShop(row) {
      if (row.shopId) {
        this.editDialog.title = "编辑店铺"
      } else {
        this.editDialog.title = "新增店铺"
      }
      this.editDialog.dialogVisible = true
      this.editDialog.shopForm = {
        shopId: row.shopId,
        shopName: row.shopName,
        amazonSite: row.amazonSite,
      }
    },
    /**保存店铺信息 */
    saveShop() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.editDialog.shopForm.shopId) {
            updateShop(this.editDialog.shopForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("修改失败")
              }
            })
          } else {
            addShop(this.editDialog.shopForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("新增失败")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**显示授权页面 */
    handleShowAuthShop(row) {
      this.authDialog.dialogVisible = true
      this.authDialog.shopForm = Object.assign({}, row)
    },
    /**授权店铺信息 */
    saveAuthShop() {
      this.$refs["ruleAuthForm"].validate((valid) => {
        if (valid) {
          giveShopAuth(this.authDialog.shopForm).then((response) => {
            if (response.code == "200") {
              this.$message.success("授权成功！")
              this.authDialog.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error("授权失败")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**保存店铺信息 */
    giveShopAuth(shopId, shopStatus) {
      const params = {
        shopId: shopId,
        shopStatus: shopStatus,
      }
      let imfo = "启用"
      if (shopStatus != "01") {
        imfo = "禁用"
      }
      this.$XModal
        .confirm("您确定要" + imfo + "吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
        })
        .then((type) => {
          if (type == "confirm") {
            updateShop(params).then((response) => {
              if (response.code == "200") {
                this.$message.success(imfo + "成功！")
                this.authDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error(imfo + "失败！")
              }
            })
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
